export const FIND_NEAREST_SEARCH = "FIND_NEAREST_SEARCH";
export const FIND_NEAREST_SEARCH_RESPONSE = "FIND_NEAREST_SEARCH_RESPONSE";
export const FIND_NEAREST_OPEN_DIRECTIONS_MODAL = "FIND_NEAREST_OPEN_DIRECTIONS_MODAL";